import type { NotificationConfig } from '#types/config/components/vf/notification'
import type { RecursivePartial } from '#types/utils'
import type { InjectionKey } from 'vue'

export const NotificationConfigContextKey: InjectionKey<RecursivePartial<NotificationConfig>> = Symbol('NotificationConfigContext')
